import { Avatar, Group, Text, Badge, useMantineTheme } from "@mantine/core";
import { forwardRef } from "react";
import ImageNotFound from "../../Assets/ImageNotFound.svg";

export const SelectItem = forwardRef(({ coverImage, stockNumber, label, title, description, status, ...others }, ref) => {
  const theme = useMantineTheme();
  let background = status === "Return To Auction Manager" ? { background: theme.colorScheme === "dark" ? "#555555" : "#FFC9C9" } : {};
  return (
    <div
      ref={ref}
      {...others}
      style={{
        borderBottom: "1px solid #E9ECEF",
        ...background,
      }}
    >
      <Group noWrap>
        <Avatar src={coverImage || ImageNotFound} />

        <div>
          <Text size="sm">{title}</Text>

          <Group spacing={10} align={"baseline"}>
            <Text size="sm" opacity={0.65} color={theme.colorScheme === "dark" ? "white" : "dark"}>
              <strong>Stock:</strong>
              {stockNumber}
            </Text>
            <Text size="xs" opacity={0.65}>
              <strong>VIN:</strong> {description}
            </Text>
            {status && (
              <Badge size={"sm"} color={status === "Return To Auction Manager" ? "red" : "blue"}>
                {status}
              </Badge>
            )}
          </Group>
        </div>
      </Group>
    </div>
  );
});
